<template>
  <div class="ano">
    <div class="ano__wrapper">
      <h2>{{ ano }}</h2>
    </div>
  </div>
</template>

<script>
export default {
  props: ['ano'],
};
</script>

<style lang="scss" scoped>
.ano {
  min-height: 100vh;
  margin-bottom: -90px;
  position: relative;

  &__wrapper {
    top: 0;
    position: sticky;
    z-index: 10;
  }
  h2 {
    color: color(cGray);
    text-align: center;
    font-family: font(primary);
    font-size: 18.75rem;
    font-style: normal;
    font-weight: 800;
    line-height: normal;
    white-space: nowrap;
    transform-origin: bottom;
    text-align: center;
    font-size: 19rem;
    @include media('<=desktop') {
      font-size: 8.5rem;
    }
  }
}
</style>
